import React, { useEffect, useState } from "react"
import { Card, Container, Row } from "react-bootstrap"

import CRUDField from "../core/genericCRUD/CRUDField"
import FieldSelector from "../core/FieldSelector"
import { useTranslation } from "react-i18next"
import { useFormik } from "formik"
import * as yup from "yup"
import yupTypeValidator from "../../common/YupTypeValidator"
import API from "../../common/API"
import { parsedUser } from "../../common/GetCurrentUser"

import LaborAccessRequestDTO from "./LaborAccessRequestDTO"


import { Base64ToFile } from "../../common/helpers"

const LaborAccessRequestExternal = props => {
  // PROPERTIES
  const [record, setRecord] = useState<any>(null)
  const [completeRequest, setCompleteRequest] = useState<boolean>(false)
  const fields: CRUDField[] = LaborAccessRequestDTO
  const { t } = useTranslation("global")
  const [formikInitialObject, setFormikInitialObject] = useState<any>({})
  const [validationsSchema, setValidationSchema] =
    useState<yup.ObjectSchema<any>>()
  const [isLoading, setIsLoading] = useState(false)
  const user = parsedUser()
  const formik = useFormik({
    initialValues: formikInitialObject,
    enableReinitialize: true,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: validationsSchema,
    onSubmit: () => handleSubmit(),
  })
  type YupSchema =
    | yup.StringSchema
    | yup.BooleanSchema
    | yup.NumberSchema
    | yup.DateSchema
  // METHODS

  const fillFormikObject = (record: any) => {
    fields.forEach((item: CRUDField) => {
      if (item && item.name.length > 0) {
        //console.log("field name", item.name, "RecordValue ", record[item.name]);
        if (record && record[item.name]) {
          formik.setFieldValue(item.name, record[item.name])
        }
      }
    })
  }

  const prepareFormikObject = () => {
    const initialObject: { [key: string]: string } = {}
    const initialObjectValidation: { [key: string]: YupSchema } = {}

    if (fields) {
      fields.forEach((item: CRUDField) => {
        // if (item.FieldName === "Id" || item.FieldName === "File") return;

        initialObject[item.name] = item.value

        if (item.required) {
          const schema = yupTypeValidator(item)
          if (schema) {
            initialObjectValidation[item.name] = schema
          }
        }
      })
    }

    // formik.initialValues = initialObject;
    setFormikInitialObject(initialObject)
    setValidationSchema(yup.object().shape(initialObjectValidation))
  }
  const resultadosRnc = async (value: any) => {
    // formik.setFieldValue("cedula", value)
    let item = value[0]
    if (item) {
      formik.setFieldValue("companyName", item.nombre)
    }
    console.log("relatives", value)
  }
  const updateField = (fieldName: string, fieldValue: any) => {
    //console.log(fieldName, fieldValue)
    formik.setFieldValue(fieldName, fieldValue)
  }


  const resultadosCedula = async (value: any, field?: string) => {
    // formik.setFieldValue("cedula", value)
    // debugger;
    console.log("cedula", value, field)
    let item = value[0]
    if (item) {

      if (field && field === 'responsableId') {

        formik.setFieldValue("responsableName", item.nombres + " " + item.apellido1 + " " + item.apellido2)

      }
      if (field && field === 'secondResponsableId') {

        formik.setFieldValue("secondResponsableName", item.nombres + " " + item.apellido1 + " " + item.apellido2)

      }


      if (item.imagen) {
        let file = Base64ToFile(
          "data:image/jpeg;base64," + item.imagen,
          item.cedula + ".jpg"
        )
        let bodyData = new FormData()
        bodyData.append("path", file)
        const request = await API.postAction(`File/Upload`, bodyData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        if (field === 'secondResponsableId') {
          formik.setFieldValue("secondResponsablePhoto", request.data.response)
        }
        if (field === 'responsableId') {
          formik.setFieldValue("responsablePhoto", request.data.response)
        }
      }
    }
    console.log("relatives", value)
  }
  const selectMapSearch = async (value: any) => {
    formik.setFieldValue("latitude", value.geometry.location.lat)
    formik.setFieldValue("longitude", value.geometry.location.lng)
    formik.setFieldValue("locationMap", {
      lat: value.geometry.location.lat,
      lng: value.geometry.location.lng,
    })
  }

  const handleSubmit = async (shouldContinue?: boolean | undefined) => {
    try {
      console.log("values to submit", formik.values)

      let query = {}
      fields.forEach((item: CRUDField) => {
        if (item && item.htmlType !== "separator" && item.name.length > 0) {
          query[item.name] = formik.values[item.name] ?? null
        }
      })

      query["locationMap"] = undefined
      query["organizationId"] = user.OrganizationId
      console.log(query)
      setIsLoading(true)
      let request = (await API.postAction(
        `laborAccessRequest/AddEdit`,
        query
      )) as any
      if (request.data.status === "ok") {
        setCompleteRequest(true)
        setRecord(request.data.response)
      }
    } catch (ex) {
      console.error(ex)
    } finally {
      setIsLoading(false)
    }
  }

  const bindDataRemote = async () => {
    try {
      if (record === null) return
      console.log("bind data remote", record)
      setIsLoading(true)
      let request = await API.getAction(
        "laborAccessRequest/Details?id=" + record.id
      )
      if (request.data.status === "ok") {
        fillFormikObject(request.data.response)

        formik.setFieldValue("locationMap", {
          lat: request.data.response.latitude,
          lng: request.data.response.longitude,
        })
      }
    } catch (e) {
      console.error(e)
    } finally {
      setIsLoading(false)
    }
  }
  // EVENTS
  useEffect(() => {
    prepareFormikObject()
  }, [])

  useEffect(() => {
    setRecord(props.record)
  }, [props.record])

  useEffect(() => {
    console.log("load remote content")
    bindDataRemote()
  }, [record])


  if (completeRequest) {
    return (
      <Container>
        <div className="flex gap-2 flex-col px-4  my-4 py-4 text-center">
          <div className="alert alert-success">
            <strong>Solicitud exitosa!</strong><br />
            Solicitud recibida, nos contactaremos a la brevedad.
          </div>

          <button className="btn btn-outline-primary my-4" onClick={() => window.location.reload()}>Crear otra solicitud</button>
        </div>
      </Container>)

  }
  return (
    <Container>



      <div className="flex gap-2 flex-col p-4" >
        <Card className="my-4">
          <Card.Header>
            <Card.Title className="text-uppercase">{t("Solicitud de acceso laboral")}</Card.Title>
          </Card.Header>
          <Card.Body>
            <Row>
              {fields &&
                fields
                  .filter(x => x.htmlType !== "hidden")
                  .map((item, index) => {
                    return (
                      <FieldSelector
                        key={index}
                        model={{
                          ...item,
                          readOnly: props.readOnly ?? false,
                        }}
                        resultadosRnc={resultadosRnc}
                        updateField={updateField}
                        selectMapSearch={selectMapSearch}

                        resultadosCedula={resultadosCedula}
                        obj={formik.values}
                        value={
                          formik.values[item.name as keyof typeof formik.values]
                        }
                        errors={formik.errors}
                      />
                    )
                  })}
            </Row>
          </Card.Body>
          <Card.Footer className="text-end">
            {/* <button
              className="btn btn-secondary me-2"
              disabled={isLoading}
              onClick={() => props.toggle()}
              type="button"
            >
              {t("Cancel")}
            </button> */}


            {isLoading && (
              <div className="me-4 d-inline-block">
                <div className="spinner-border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            )}

            <button
              className="btn btn-primary text-white"
              disabled={isLoading}
              onClick={() => formik.submitForm()}
              type="button"
            >
              {t("Save")}
            </button>
          </Card.Footer>
        </Card>

      </div>

    </Container>
  )
}

export default LaborAccessRequestExternal
